module.exports = __webpack_public_path__ + "static/media/cq_ricevi_messaggio.df811f48.svg";